var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.overlayIsVisible)?_c('div',{staticClass:"ui-overlay",on:{"click":_vm.collapseOverlay}}):_vm._e(),_c('error-handler',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }